import {HttpParams} from '@angular/common/http';
import { ListQuery } from '@ose/models';

export const toHttpParams = (obj: ListQuery): HttpParams => {
  let httpParams = new HttpParams();
  const { page, length, ...rest } = obj;

  if (length !== undefined) {
    httpParams = httpParams.set('take', length.toString());
  }

  if (page !== undefined && length !== undefined) {
    const skip = (page - 1) * length;
    httpParams = httpParams.set('skip', skip.toString());
  }

  Object.entries(rest).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(val => {
        httpParams = httpParams.append(key, val);
      });
    } else if (value !== null && value !== undefined) {
      httpParams = httpParams.set(key, String(value));
    }
  });

  return httpParams;
};

export const toFormData = (obj: any, form?: FormData, namespace?: string): FormData => {
  const formData = form || new FormData();

  for (const property in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, property) || obj[property] === undefined || obj[property] === null) {
      continue;
    }

    const formKey = namespace ? `${namespace}[${property}]` : property;
    const value = obj[property];

    if (value instanceof Date) {
      formData.append(formKey, value.toISOString());
    } else if (value instanceof File || value instanceof Blob) {
      formData.append(formKey, value);
    } else {
      formData.append(formKey, value.toString());
    }
  }

  return formData;
}
